import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 14 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.191923 5.14493C0.0752372 5.23632 0 5.38017 0 5.54197C0 5.56075 0.00101353 5.57929 0.00298776 5.59753C0.00126393 5.61891 0.00039157 5.64044 0.00039157 5.66207V18.374C0.00039157 19.2721 0.71291 20 1.59212 20H12.4083C13.2875 20 14 19.2721 14 18.374V1.62609C14 0.727954 13.2875 0.000100012 12.4083 0.000100012H5.76137C5.74116 0.000100012 5.72103 0.000920717 5.70102 0.00254447C5.68472 0.000865334 5.66818 3.60314e-06 5.65144 1.12663e-08C5.50245 -3.1949e-05 5.369 0.0679371 5.2792 0.17519C5.26322 0.188484 5.24771 0.20248 5.23274 0.217159L5.2322 0.217682L0.236732 5.09772C0.221086 5.11284 0.206142 5.1286 0.191923 5.14493ZM5.16163 1.67028L1.71017 5.04198H5.16094L5.16163 1.67028ZM6.14069 1.0001L6.13982 5.26097C6.13982 5.69254 5.79691 6.04197 5.3743 6.04197H0.979317V18.374C0.979317 18.7199 1.25356 19 1.59212 19H12.4083C12.7468 19 13.0211 18.7199 13.0211 18.374V1.62609C13.0211 1.28024 12.7468 1.0001 12.4083 1.0001H6.14069Z"
      />
    </svg>
  );
}
